/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BuildingBadgeDto } from './buildingBadgeDto';
import { BuildingEquipmentItemDto } from './buildingEquipmentItemDto';
import { MaintenanceTimerPermissions } from './maintenanceTimerPermissions';
import { TenantItemDto } from './tenantItemDto';
import { UserItemDto } from './userItemDto';


export interface MaintenanceTimerDetailDto { 
    id: string;
    created: string;
    building?: BuildingBadgeDto;
    buildingEquipment: BuildingEquipmentItemDto;
    type: MaintenanceTimerDetailDto.TypeEnum;
    creatorTenant: TenantItemDto;
    lastModifiedBy?: UserItemDto;
    lastModifiedByName?: string;
    startDate: string;
    durationDays: number;
    nextDate: string;
    earlyToleranceDays: number;
    lateToleranceDays: number;
    reminderDate: string;
    reminderDurationDays: number;
    iterations: number;
    imagesMandatory: boolean;
    permissions: MaintenanceTimerPermissions;
    isAllowedToFinish: boolean;
    lastFinisherTenantName?: string;
    lastFinisherName?: string;
    lastFinishWasInTime?: boolean;
    lastFinishedAt?: string;
    overdueDays?: number;
}
export namespace MaintenanceTimerDetailDto {
    export type TypeEnum = 'Maintenance' | 'Inspection' | 'SelfInspection' | 'Warranty';
    export const TypeEnum = {
        Maintenance: 'Maintenance' as TypeEnum,
        Inspection: 'Inspection' as TypeEnum,
        SelfInspection: 'SelfInspection' as TypeEnum,
        Warranty: 'Warranty' as TypeEnum
    };
}


